/**
 * Lightweight wallet connect for blog app (same accounts as main Workloob platform).
 */
export async function connectInjectedWallet() {
  const { ethereum } = window;
  if (!ethereum) {
    throw new Error('No Web3 wallet found. Install MetaMask or another wallet extension.');
  }
  const accounts = await ethereum.request({ method: 'eth_requestAccounts' });
  if (!accounts?.length) {
    throw new Error('Wallet connection was cancelled.');
  }
  return accounts[0];
}
